export default __webpack_public_path__ + "static/404-4ee52ff3584b4f8b856f599e6d0c917d.png";